import { type PostConsentPayload } from '@carvana/core-consent';
import { type AxiosResponse } from 'axios';
import { consentApiUrl } from '../../environment';
import { axiosWithAuth } from '../../utilities';

type RawConsent = {
  Channel?: string;
  IsExplicitConsent?: boolean;
  IsOptedIn?: boolean;
  TypeName?: string;
  channel?: string;
  isExplicitConsent?: boolean;
  isOptedIn?: boolean;
  typeName?: string;
};

export type NormalizedConsent = {
  channel: string;
  isExplicitConsent: boolean;
  isOptedIn: boolean;
  typeName: string;
};

export type ConsentUpdateRequest = Omit<PostConsentPayload, 'consentType'> & {
  consentType: string; // TODO: Update core-consent package to support the types that we need to send
};

const normalizeConsent = (consent: RawConsent): NormalizedConsent => ({
  typeName: consent.typeName ?? consent.TypeName ?? '',
  channel: consent.channel ?? consent.Channel ?? '',
  isOptedIn: consent.isOptedIn ?? consent.IsOptedIn ?? false,
  isExplicitConsent: consent.isExplicitConsent ?? consent.IsExplicitConsent ?? false
});

export default class ConsentApi {
  static getConsents(userId: string): Promise<AxiosResponse<{ content: NormalizedConsent[] }>> {
    const endpoint = `${consentApiUrl}/v1/consent/users/${userId}`;
    return axiosWithAuth()
      .get(endpoint)
      .then((response) => ({
        ...response,
        data: {
          ...response.data,
          content: (response.data.content || []).map(normalizeConsent)
        }
      }));
  }

  static updateConsents(request: ConsentUpdateRequest[]) {
    const endpoint = `${consentApiUrl}/v2/consent`;
    return axiosWithAuth().post(endpoint, request);
  }

  static updateCcpaOptOut() {
    // This endpoint is used to update the CCPA opt-out status for third-party sharing
    // It does not require any request body as per the current API design
    // The endpoint is expected to handle the opt-out logic internally
    const endpoint = `${consentApiUrl}/v1/consent/ccpa-third-party-opt-out`;
    return axiosWithAuth().post(endpoint);
  }
}
